import React from 'react';

import { Spinner } from '../../spinner/spinner';

export interface DefaultSecondaryButtonProps {
    id?: string;
    text: React.ReactNode;
    icon?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
    href?: string;
    target?: React.HTMLAttributeAnchorTarget;
    rel?: string;
    disabled?: boolean;
    isLoading?: boolean;
    dataTestId?: string;
    size?: 'sm' | 'md' | 'lg';
}

const variant = {
    sm: 'h-10 px-3 text-sm',
    md: 'h-12 px-4 text-base',
    lg: 'h-14 px-5 text-base min-w-48'
};

const buttonClassName = (size?: 'sm' | 'md' | 'lg') =>
    `text-brand-primary hover:text-brand-secondary disabled:text-brand-muted hover:border-brand-secondary disabled:border-brand-disabled border-brand-primary inline-flex cursor-pointer items-center justify-center gap-2 rounded-md border disabled:cursor-not-allowed ${size ? variant[size] : variant.md}`;

export const DefaultSecondaryButton = (props: DefaultSecondaryButtonProps) => {
    const content = (
        <div className='flex content-center items-center justify-center gap-2 font-medium whitespace-nowrap'>
            {props.isLoading && <Spinner className='text-border-default fill-brand-primary size-4' />}
            {props.text}
            {props.icon}
        </div>
    );

    if (props.href && !props.disabled && !props.isLoading) {
        return (
            <a
                id={props.id}
                href={props.href}
                target={props.target}
                rel={props.rel}
                onClick={props.onClick}
                data-testid={props.dataTestId ?? 'secondary-button'}
                className={buttonClassName(props.size)}>
                {content}
            </a>
        );
    }

    return (
        <button
            id={props.id}
            disabled={props.disabled || props.isLoading}
            onClick={props.onClick}
            data-testid={props.dataTestId ?? 'secondary-button'}
            className={buttonClassName(props.size)}>
            {content}
        </button>
    );
};
